import { AutoComplete, Input } from "antd";
import { SearchIcon } from "lucide-react";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAutocompleteProduct } from "services/product";
import {
  trackProductSearch,
  trackSearchAutocompleteSelect,
} from "../../utils/analytics";

interface ISearchInput {
  width?: string;
}
const SearchInput: FC<ISearchInput> = ({ width = "500px" }) => {
  const navigate = useNavigate();
  const [searchQs, setSearchQs] = useState<string>("");
  const [searchValue, setSearchValue] = useState<string>("");
  const { suggestProductList } = useGetAutocompleteProduct(searchQs);

  const handleSearchProduct = async (value: string) => {
    setSearchQs(value);

    // Only track searches with meaningful content (at least 2 characters)
    if (value && value.trim().length >= 2) {
      trackProductSearch(value);
    }
  };

  const handleChangeSearch = (value: string) => {
    setSearchValue(value);
  };

  return (
    <AutoComplete
      size="large"
      style={{ width }}
      onSearch={handleSearchProduct}
      onChange={handleChangeSearch}
      onSelect={(value: string) => {
        // Track when user selects an item from autocomplete
        trackSearchAutocompleteSelect(searchValue, value);
        navigate("/search/" + encodeURIComponent(value));
      }}
      options={suggestProductList?.map((p) => ({
        value: p.name,
        label: (
          <div>
            <div>{p.name}</div>
            {p.genericName && (
              <div className="text-xs text-gray-500">{p.genericName}</div>
            )}
          </div>
        ),
      }))}
      popupClassName="search-product-input"
    >
      <Input
        size="large"
        prefix={<SearchIcon color="#828282" size={20} />}
        placeholder="ค้นหา ชื่อการค้า, Generic name, รหัสสินค้า, Barcode"
        style={{ borderRadius: "100px", width: "100%" }}
        onPressEnter={() => {
          // Track when user presses enter to search
          if (searchValue && searchValue.trim().length > 0) {
            trackProductSearch(searchValue);
          }
          navigate("/search/" + encodeURIComponent(searchValue));
        }}
      />
    </AutoComplete>
  );
};
export default SearchInput;
